import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import MissingValue from './MissingValue';
import List from './List';
import Link from './Link';
import Email from './Email';
import Text from './Text';
import DateTime from './DateTime';
import Duration from './Duration';
import Switch from './Switch';
import job from './job';
import engagement from './engagement';
import Placeholders from './Placeholders';
import DataLink from './DataLink';
import LetterAvatar from './LetterAvatar';
/**
 * Formatter namespace
 */

var FORMATTER_API = _objectSpread({
  MissingValue: MissingValue,
  List: List,
  Link: Link,
  Email: Email,
  Text: Text,
  DateTime: DateTime,
  Switch: Switch,
  Duration: Duration,
  LetterAvatar: LetterAvatar
}, job, engagement, {
  Placeholders: Placeholders,
  DataLink: DataLink
});

export default FORMATTER_API;